export default __webpack_public_path__ + "static/media/1.f0d30c54.jpeg";